import $ from "jquery";
import CustomConfigurator from "../../../../../app/javascript/CustomConfigurator";
import { dbwvRoutes, dbwvUserbarRoutes } from "../components/routes";

CustomConfigurator.set("routes", dbwvRoutes);
CustomConfigurator.set("userbarRoutes", dbwvUserbarRoutes);
CustomConfigurator.set("membershipsUserbar.extraLinks", [
  { to: "/custom/dbwv/mitgliedschaft/edit", label: "Meine Daten" },
]);

$(function() {
  var oauthAppName;
  oauthAppName = localStorage.getItem('oauthAppName');
  if (!_.isEmpty(oauthAppName)) {
    console.log('Apply dbwv custom oauth styles for', oauthAppName);
    return $('body').addClass(oauthAppName.replace(/[^a-z0-9-_]/gi, '_'));
  }
});
